(() => {
  if (window.PRPProductOptionsLoaded) return;
  window.PRPProductOptionsLoaded = true;

  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest(
        'product-form button[type="submit"], product-form input[type="submit"]'
      );

      if (!button) return;

      const productForm = button.closest('product-form');
      const form = button.closest('form[action*="/cart/add"]');

      if (!productForm || !form) return;

      const linkedBlocks = Array.from(
        form.querySelectorAll(
          '[data-prp-product-option][data-prp-behaviour="linked_product"]'
        )
      );

      if (!linkedBlocks.length) {
        return;
      }

      const formData = new FormData(form);

      const quantity = Math.max(
        1,
        parseInt(formData.get('quantity') || '1', 10) || 1
      );

      const linkedItems = [];

      linkedBlocks.forEach((block) => {
        const select = block.querySelector('select');

        if (!select) return;

        const selectedOption =
          select.options[select.selectedIndex];

        const linkedVariantId =
          selectedOption?.dataset?.linkedVariantId;

        if (!linkedVariantId) return;

        linkedItems.push({
          id: Number(linkedVariantId),
          quantity
        });
      });

      /*
       * No linked product selected.
       * Example: No Crank Gear.
       * Let Empire handle Add to Cart normally.
       */
      if (!linkedItems.length) {
        return;
      }

      const mainVariantId = Number(
        formData.get('id')
      );

      if (!mainVariantId) {
        return;
      }

      /*
       * Stop Empire from performing its own separate cart add.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      button.disabled = true;

      const properties = {};

      for (const [key, value] of formData.entries()) {
        const match =
          key.match(/^properties\[(.*)\]$/);

        if (
          match &&
          value !== null &&
          String(value).trim() !== ''
        ) {
          properties[match[1]] = value;
        }
      }

      const mainItem = {
        id: mainVariantId,
        quantity
      };

      if (Object.keys(properties).length) {
        mainItem.properties = properties;
      }

      const sellingPlan =
        formData.get('selling_plan');

      if (sellingPlan) {
        mainItem.selling_plan = sellingPlan;
      }

      const items = [
        mainItem,
        ...linkedItems
      ];

      const errorMessage =
        form.querySelector(
          '[data-prp-product-option-error]'
        );

      if (errorMessage) {
        errorMessage.hidden = true;
      }

      try {
        const root =
          window.Shopify?.routes?.root || '/';

        const response = await fetch(
          `${root}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items
            })
          }
        );

        const responseData =
          await response.json();

        if (!response.ok) {
          throw responseData;
        }

        prepareDataForDisplayWidgetByRule();
        return;
      } catch (error) {
        console.error(
          'PRP linked product add failed:',
          error
        );

        if (errorMessage) {
          errorMessage.hidden = false;
        }
      } finally {
        button.disabled = false;
      }
    },
    true
  );
})();